import React, { useState } from "react";
import style from "./university.module.css";
import { useNavigate } from "react-router-dom";
import { baseUrl } from '../../utils/api';
import axios from "axios";
import { toast } from "react-toastify";
const University = () => {

  const [email, setEmail] = useState("");
  const [university, setUniversity] = useState("");

  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    try {


      e.preventDefault();

      if (!email) return;

      const res = await axios.post(`${baseUrl}/admin/uniinterest`, {
        email: email,
        university_interest: university
      });

      if (res) {
        console.log("res", res.data)
        toast.success(res.data)
      }


      setEmail("");
      setUniversity("");
    }
    catch (error) {
      toast.error(error)
    }
  };

  return (
    <div className={style.outermain}>
      <div className="container">
        <div className={style.mainhbcu}>
          <div className={style.hbcuCard}>
            <div className={style.hbcubus}>
              <img src="hbcu.png" alt="HBCU Hope Project Bus" />
            </div>
            <div className={style.maincontenthbcu}>
              <p>Thank you for your interest in supporting HBCU Hope Project. We are currently raising funds exclusively for Texas Southern University and Prairie View A&M University to complete the purchase of our Mobile Pregnancy Care Unit. This church-led community outreach effort focuses on serving students near these campuses by providing compassionate, practical support to those facing an unexpected pregnancy, helping them stay on track toward graduation. </p>
              <p>We would be grateful for your partnership as we take this important first step with TSU and Prairie View. If you would like to receive updates or be notified when campaigns expand to additional schools, please leave your email below. Thank you for standing with us and for caring about the future of these students.</p>
            </div>
          </div>
          <div className={style.hbcubutton}>
            <button onClick={() =>
              navigate("/donation/the-hbcu-hope-project-at-tsu")
            }>
              Support TSU
            </button>

            <button onClick={() =>
              navigate("/donation/the-hope-project-at-pvamu")
            }>
              Support PVAMU
            </button>
          </div>
          <form className={style.hbcusignup} onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <select
              value={university}
              onChange={(e) => setUniversity(e.target.value)}
            >
              <option value="">University of interest</option>
              <option>North Carolina Agricultural and Technical State University</option>
              <option>North Carolina Central University</option>
              <option>Morgan State University</option>
              <option>Hampton University</option>
              <option>Spelman College</option>
              <option>Howard University</option>
              <option>Clark Atlanta University</option>
              <option>Florida A&M University</option>
              <option>Morehouse College</option>
              <option>Grambling state university</option>
              <option>Jackson State University</option>
              <option>Dillard University</option>
              <option>Southern University and agricultural and mechanical college
              </option>
            </select>


            <button type="submit" className={style.signupbtn} onClick={handleSubmit}>
              Submit
            </button>
          </form>
        </div>



      </div>
    </div>
  );
};

export default University;
